import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ProductShippingGuidance.styled';
import { trackEvent as dataLayerPush } from '../../../../util/track';

/**
 * This component uses Narvar's Estimated Delivery Date (EDD) service, which gives estimated shipping dates.
 *
 * The core logic is a snippet hosted in GTM and this component is a wrapper for it.
 *
 * For more information about this service, @see {@link https://narvar.app.box.com/s/gsne599l4kpl532s6tra20pt97prtlw0}
 */
const ProductShippingGuidance = ({ className }) => {
  useEffect(() => {
    dataLayerPush({ event: 'initNarvarEDD' });
  }, []);

  return (
    <Styled.ProductShippingGuidance
      data-narvar-feature="eddCalculator"
      className={className}
    />
  );
};

ProductShippingGuidance.propTypes = {
  /**
   * A classname, intented to extend this component with styles provided from styled components
   */
  className: PropTypes.string.isRequired
};

export default ProductShippingGuidance;
